import styled from '@emotion/styled';
import { rem } from '@triumph/design-system';

import { CONTENT_PADDING_TOP } from '@/components/shared/components/Layout/Layout.StyledComponents';

import { CARD_MAX_WIDTH } from '../../Applicant.StyledComponents';

export const SubmissionsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${rem(24)};
`;

// Capped like the cards below, so on a wide screen each picker ends where its card ends. The
// label sits inside the field, top-aligned over the value, like PrimeReact 11's IftaLabel, which
// 10 lacks.
export const SubmissionPicker = styled.div`
    position: relative;
    display: flex;
    min-width: 0;
    max-width: ${CARD_MAX_WIDTH};

    label {
        position: absolute;
        top: ${rem(5)};
        left: ${rem(7)};
        z-index: 1;
        font-size: ${rem(11)};
        font-weight: 600;
        line-height: 1;
        color: #6b7280;
        pointer-events: none;
    }

    .p-dropdown {
        flex: 1;
        min-width: 0;
    }

    .p-dropdown-label {
        overflow: hidden;
        text-overflow: ellipsis;
        padding-top: ${rem(19)};
        padding-bottom: ${rem(5)};
    }
`;

// Each picker spans the card below it: split, the two halves of CompareColumns; otherwise the one card,
// with Compare with taking what is left and wrapping under it when that gets too narrow.
// Pinned flush under the app bar like the Conditions section headers, above the cards it covers.
export const SubmissionPickers = styled.div<{ $isSplit: boolean }>`
    position: sticky;
    top: calc(-1 * ${CONTENT_PADDING_TOP});
    z-index: 3;
    padding: ${rem(8)} 0;
    margin: -${rem(8)} 0;
    background: #ffffff;
    gap: ${rem(24)};
    ${({ $isSplit }) =>
        $isSplit
            ? `
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
    `
            : `
        display: flex;
        flex-wrap: wrap;

        > :first-of-type {
            flex: 1 1 100%;
        }

        > :not(:first-of-type) {
            flex: 1 1 ${rem(360)};
        }
    `}
`;

export const CompareColumns = styled.div<{ $isSplit: boolean }>`
    display: grid;
    grid-template-columns: ${({ $isSplit }) => ($isSplit ? 'repeat(2, minmax(0, 1fr))' : 'minmax(0, 1fr)')};
    gap: ${rem(24)};
    align-items: start;
`;

// One shared grid, so each section row is as tall as its taller side and both sides start level.
export const AlignedCompareGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: ${rem(24)};
    row-gap: ${rem(24)};
    align-items: start;
`;
